<!-- QrScanner.vue -->
<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full relative">
      <h2 class="text-xl font-bold mb-4">📷 Escanear Certificado</h2>

      <video ref="videoRef" class="w-full rounded border" autoplay muted playsinline></video>

      <div v-if="resultado" class="mt-6 border-t pt-4 text-sm space-y-2">
        <p><strong>ID:</strong> {{ resultado.id }}</p>
        <p><strong>Nombre:</strong> {{ resultado?.destinatario?.nombre || 'N/A' }}</p>
        <p><strong>Monto:</strong> ${{ resultado.monto?.toFixed(2) || '0.00' }}</p>
        <p><strong>Tipo:</strong> {{ resultado.tipo }}</p>
        <p><strong>Descripción:</strong> {{ resultado.descripcion || 'No especificada' }}</p>
        <p><strong>Estado:</strong>
          <span :class="resultado.redimido ? 'text-red-600' : 'text-green-600'">
            {{ resultado.redimido ? 'Redimido' : 'Disponible' }}
          </span>
        </p>

        <button
          v-if="!resultado.redimido"
          @click="redimir"
          class="btn-primary mt-4"
        >
          Redimir y aplicar al carrito
        </button>
      </div>

      <button @click="cerrar" class="absolute top-2 right-3 text-gray-400 hover:text-gray-700 text-lg">×</button>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import { ref, onMounted, onBeforeUnmount } from 'vue'
import { BrowserQRCodeReader } from '@zxing/browser'
import { verificarCertificado, redimirCertificado } from '@/utils/certificados'

const emit = defineEmits(['close', 'certificadoAplicado'])

const videoRef = ref(null)
const resultado = ref(null)
let codeReader = null
let controls = null

onMounted(async () => {
  codeReader = new BrowserQRCodeReader()

  try {
    controls = await codeReader.decodeFromVideoDevice(
      null,
      videoRef.value,
      async (result, err) => {
        if (result) {
          await procesarQR(result.getText())
          if (controls) controls.stop()
        }
      }
    )
  } catch (e) {
    alert("❌ No se pudo acceder a la cámara.")
    console.error(e)
  }
})

onBeforeUnmount(() => {
  if (controls) controls.stop()
  // ❌ NO uses codeReader.reset()
})

async function procesarQR(textoQR) {
  try {
    const data = JSON.parse(textoQR)
    if (!data.id) throw new Error('QR inválido: falta ID')

    const cert = await verificarCertificado(data.id)

    resultado.value = {
      ...data,
      ...cert, // da prioridad a Firestore
    }

    // Asegúrate de uniformar la propiedad `monto`
    resultado.value.monto = cert.valor || data.valor || 0

  } catch (err) {
    alert("❌ Código inválido o certificado no encontrado.")
    console.error(err)
  }
}


async function redimir() {
  try {
    await redimirCertificado(resultado.value.id)
    resultado.value.redimido = true

    emit('certificadoAplicado', {
      tipo: resultado.value.tipo,
      descripcion: resultado.value.descripcion,
      monto: resultado.value.monto,
      uuid: resultado.value.id,
    })

    alert('✅ Certificado redimido y aplicado.')
    cerrar()
  } catch (e) {
    console.error(e)
    alert('Error al redimir el certificado.')
  }
}

function cerrar() {
  if (controls) controls.stop()
  resultado.value = null
  emit('close')
}
</script>


<style scoped>
.btn-primary {
  @apply bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700;
}
</style>
